module.exports = __webpack_public_path__ + "img/compressed-2018226223368507392.0d33cef2.png";